module.exports = __webpack_public_path__ + "img/chargerID@2x.c7894654.png";